<template>
    <div background="./assets/bg.png" leftmargin="0" topmargin="0" marginwidth="0" marginheight="0"
        ondragstart="return false">
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
            integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
            crossorigin="anonymous" />
        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.13.0/css/all.css"
            integrity="sha384-Bfad6CLCknfcloXFOyFnlgtENryhrpZCe29RTifKEixXQZ38WheV+i/6YWSzkz3V"
            crossorigin="anonymous" />
        <div v-if="ShowLoginPage" class="container" style="font-size: 1em; font-family: 微軟正黑體">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <img src="../../assets/puiva_building.jpg" class="img-fluid mx-auto d-block my-5" />
                    <h3 class="text-center mb-5">幼兒首次入學錄取結果查詢</h3>
                </div>
                <div class="col-md-3"></div>
            </div>
            <div class="row text-center">
                <div class="col-md-3"></div>
                <div class="col-md-6 text-center">
                    <form onsubmit="return false;" autocomplete="on">

                        <div class="input-group mb-3">
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">賬號</span>
                            </div>
                            <input type="text" class="form-control" placeholder="考生證件號碼前7位" name="PVUserName"
                                v-model="PVUserName" required autofocus />
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2">密碼</span>
                            </div>
                            <input type="password" class="form-control" placeholder="登記接收短訊之家長手提電話號碼" v-model="Password"
                                name="Password" required />
                        </div>
                        <!-- <div class="form-check-inline">
                            <label class="form-check-label">
                                <input type="radio" class="form-check-input" name="usertype" value="student" checked />教師
                            </label>
                        </div> -->
                        <!-- <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" name="usertype" value="staff" />教職員工
                </label>
              </div>-->
                        <div>
                            <div v-if="Error" class="alert alert-danger" role="alert">
                                {{ Error }}
                            </div>
                        </div>
                        <button @click="login" class="btn btn-lg btn-primary btn-block my-5" type="submit"
                            name="submit-form">
                            登入
                        </button>
                    </form>
                </div>

            </div>
        </div>
        <div v-if="!ShowLoginPage && Result == '錄取'" class="container" style="font-size: 1em; font-family: 微軟正黑體">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div class="card text-center">
                        <div class="card-header">
                            錄取結果
                        </div>
                        <div class="card-body">
                            <h5 class="card-title">恭喜您！{{ ChiName }}小朋友已獲錄取。</h5>
                            <p class="card-text text-left">
                            <pre
                                style="color: red;white-space: pre-wrap;font-size: 1em;">&nbsp;&nbsp;&nbsp;&nbsp;家長請於4月8-10日在教青局網頁確認入讀，並於4月13-15日期間上午9:00-12:00、下午2:00-5:00親臨本校為&nbsp;貴子弟辦理註冊手續，請帶備父、母及學生身份證副本、留位費澳門幣800元。</pre>
                            </p>
                            <p class="card-text text-left">* 未經批准，逾期辦理則當自動放棄學位處理。</p>
                            <p>查詢電話：28855019/28855020(李小姐/張小姐)</p>
                        </div>
                        <div class="card-footer text-body-secondary">

                        </div>
                    </div>
                </div>
                <div class="col-md-3"></div>
            </div>
        </div>
        <div v-if="!ShowLoginPage && Result == '候補'" class="container" style="font-size: 1em; font-family: 微軟正黑體">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div class="card text-center">
                        <div class="card-header">
                            錄取結果
                        </div>
                        <div class="card-body">

                            <h5 class="card-title">培華中學温馨提示：</h5>
                            <pre style="white-space: pre-wrap;font-size: 1em;"
                                class="card-text text-left">&nbsp;&nbsp;&nbsp;&nbsp;感謝&nbsp;&nbsp;閣下對本校的支持，現通知&nbsp;&nbsp;貴子弟列於候補生名單中，如有學位空缺，本校將以電話方式另行通知，請家長留意。</pre>
                          
                        </div>

                    </div>
                </div>
                <div class="col-md-3"></div>
            </div>
        </div>
        <div v-if="!ShowLoginPage && Result == '不取'" class="container" style="font-size: 1em; font-family: 微軟正黑體">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div class="card text-center">
                        <div class="card-header">
                            錄取結果
                        </div>
                        <div class="card-body">
                            <h5 class="card-title">培華中學温馨提示：</h5>
                            <pre style="white-space: pre-wrap;font-size: 1em;"
                                class="card-text text-left">&nbsp;&nbsp;&nbsp;&nbsp;感謝&nbsp;&nbsp;閣下為&nbsp;&nbsp;貴子弟報讀本校，惜學位有限，抱歉&nbsp;&nbsp;貴子弟未獲錄取入讀，感謝&nbsp;&nbsp;閣下對本校的支持。</pre>
                         
                        </div>

                    </div>
                </div>
                <div class="col-md-3"></div>
            </div>
        </div>
    </div>
</template>
<script>
import api from "./api/K1";
import util from "may-ui-core/utility";

export default {
    data() {
        return {
            PVUserName: null,
            Password: null,
            Error: null,
            ShowLoginPage: true,
            examID: null,
            ChiName: null,
            EngName: null,
            Result: null
        };
    },
    methods: {
        login: function () {
            this.Error = null;
            if (!util.isEmpty(this.PVUserName) && !util.isEmpty(this.Password)) {
                api.loginForResult(this.PVUserName, this.Password).then((data) => {
                    this.ShowLoginPage = false;
                    this.examID = data.examID;
                    this.ChiName = data.ChiName;
                    this.EngName = data.EngName;
                    this.Result = data.Result;
                }).catch((data) => {
                    this.Error = data.Message;
                });
            }
        },
    },
};
</script>